/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/wifi-slash-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "WifiSlashRec";
export { I as WifiSlashRec };
